import qs from 'qs'
import Router from '@piconetworks/router-adapter'
import { call } from 'redux-saga/effects'

// let something

function* replace({ payload = {} }) {
    // if (payload.url === '/launcher/icon' && something) {
    //     something = !!(parseInt((Math.random() * 100).toFixed(0)) % 2)
    //     throw new Error('oops')
    // } else {
    //     something = !!(parseInt((Math.random() * 100).toFixed(0)) % 2)
    // }

    const {
        url,
        as = url,
        options = {
            shallow: false,
        },
        queryString,
    } = payload

    if (typeof url === 'string' && queryString) {
        const qsUrl = `${url}?${qs.stringify(queryString, { skipNulls: true })}`

        yield call(Router.replace, qsUrl, as, options)
    } else {
        yield call(Router.replace, url, as, options)
    }
}

export default replace
